import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as MesAct from '../../Actions/MesActions';
import Ticket from './Ticket';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
// import SelecteurDate from '../SelecteurDate';
// import Card, { LigneCard } from '../Card';
// import EtatTicket from './EtatTicket';

const AlertePasDeMes = () => (
    <div className="jumbotron text-center">
        <h1 className="display-4">Vous n&apos;avez aucune conversation.</h1>
    </div>
);

// const Utilisateur = ({ ind, estMessageSyndic }) => (
//     <span>
//         <img src={getGlyphe(ind, estMessageSyndic)} alt={ind.Nom} /> {ind.Nom}
//     </span>
// );

class MaMess extends Component {
    componentDidMount() {
        this.props.actions.mesObtenirMessages();
    }

    ChangementDate = (dateDebut) => {
        if (dateDebut) {
            this.props.actions.mesDateDebut(dateDebut);
        }
    };
    render() {
        const { Messages /* , DateDeb */, actions } = this.props;
        // const DateTime = new Date(DateDeb).getTime();

        /* const MessagesNonLus = Messages.filter(message => !message.VuParClient);
        const MessagesLus = Messages.filter(message => message.VuParClient && new Date(message.DateSaisie).getTime() >= DateTime);
        const lsMessages = MessagesNonLus.concat(MessagesLus).map((message, index) => (
            <LigneMessage key={index} Mes={message} history={history} actions={this.props.actions} />
        )); */

        // Récupère les messages non lu
        const MessagesNonLus = Messages.filter(message => !message.VuParClient);

        /* On récupère toutes le dernier messages de toutes les affaires */
        const numAffaires = new Map();
        const lsMessages = Messages.filter((message) => {
            const affaireDejaVue = numAffaires.has(message.NumAff);
            if (!affaireDejaVue) numAffaires.set(message.NumAff, 0);
            return !affaireDejaVue;
        });
        /* Ici on récupère la ligne 0 de toutes les affaires */
        /* const lsMessages = Messages.filter(message => message.NumLigne === 0); */

        return (
            <React.Fragment>
                <div className="d-flex justify-content-between mb-3">
                    {/* <SelecteurDate
                        label="Messages lus à partir du :"
                        valeurDate={DateDeb}
                        onDayChange={this.ChangementDate}
                    />
                    <div className="btn-group" role="group" aria-label="Basic example">
                        <button type="button" className="btn btn-secondary">
                            Messages non lus
                        </button>
                        <button type="button" className="btn btn-secondary">
                            Tickets en cours
                        </button>
                        <button type="button" className="btn btn-secondary">
                            Tickets cloturés
                        </button>
                    </div> */}

                    <h3>Liste des conversations</h3>
                    <div>
                        <Link to="/MaMessagerie/Ecrire" className="btn btn-primary" disabled>
                                Nouvelle demande au syndic
                        </Link>
                    </div>
                </div>
                {lsMessages.length > 0 ? (
                    lsMessages.map((message, i) => (
                        <Ticket
                            key={message.NumAuto}
                            {...message}
                            affaire={Messages.filter(msgAffaire => msgAffaire.NumAff === message.NumAff)}
                            actions={actions}
                            nonLu={MessagesNonLus.filter(msgNonLu => msgNonLu.NumAff === message.NumAff).length}
                        />
                    ))
                ) : (
                    <AlertePasDeMes />
                )}
            </React.Fragment>
        );
    }
}
MaMess.displayName = 'MaMess';
MaMess.requiredProps = [
    'Messages', // Liste des messages
    'DateDeb', // Date de début des messages lus
];

function mapStateToProps({ MesStore: { Messages, DateDeb } }) {
    return { Messages, DateDeb };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(MesAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(MaMess));



// WEBPACK FOOTER //
// ./src/components/MaMess/MaMessNG.js